import {LqbPricerLogInfo} from "./component/lqb_pricer_log_info/LqbPricerLogInfo";
import {LqbPricerModule} from "./LqbPricerLogModuleConfiguration";


LqbPricerModule.createNewModule()
    .component('lqbPricerLog', LqbPricerLogInfo.instance);